import React, { useEffect, useState, useContext } from 'react'
import {
    CognitoIdentityProviderClient,
    InitiateAuthCommand,
    RespondToAuthChallengeCommand,
  } from '@aws-sdk/client-cognito-identity-provider'

import CloudformationOutputs from '../CloudformationOutputs.json'
import { GlobalContext } from '../GlobalContext'
import { subscribe } from "../utils/pubsub"
import Spinner from "../ui-elements/Spinner"
import Button from '../formfields/Button'
import RedAlert from '../ui-elements/RedAlert'
import Modal from '../ui-elements/Modal'
import { useNavigate, useParams } from 'react-router-dom'
import Password from './auth_formfields/Password'
import Text from './auth_formfields/Text'
import { isValidCognitoPassword } from '../utils/isValidCognitoPassword'

type Props = {
    authChallenge: ObjectStringKeyAnyValue | null
    setAuthChallenge: React.Dispatch<React.SetStateAction<any>>
}


function SetNewPasswordForm({
    authChallenge,
    setAuthChallenge
}: Props) {

    const {
        tableData,
        setShowModal,
        sendMessageToWebsocket,
        currentOrganisation,
        orgIdFromQrCode,
        t
    } = useContext(GlobalContext)

    const navigate = useNavigate()
    const [formFields, setFormFields] = useState<ObjectStringKeyAnyValue>({})
    const [formErrors, setFormErrors] = useState<ObjectStringKeyAnyValue>({})




    const validate = () => {
        let isValid = true
        let newFormErrors: ObjectStringKeyAnyValue = {}

        if (
            !formFields["userName"]
        ) {
            isValid = false
            newFormErrors["userName"] = t('Auth.SetNewPasswordForm.pleaseEnterName')
        }

        if (
            !formFields["newPassword"] ||
            !isValidCognitoPassword(formFields["newPassword"])
        ) {
            isValid = false
            newFormErrors["newPassword"] = t('Auth.SetNewPasswordForm.pleaseEnterValidPassword')
        }

        if (
            formFields["newPassword"] !== formFields["newPasswordConfirm"]
        ) {
            isValid = false
            newFormErrors["newPasswordConfirm"] = t('Auth.SetNewPasswordForm.passwordsMustMatch')
        }

        setFormErrors(newFormErrors)
        return isValid
    }




    const validateAndSave = () => {
        const isValid = validate()

        if (isValid && authChallenge) {
            setShowModal({ "spinner": t('Auth.SetNewPasswordForm.sendingCode') })
            const client = new CognitoIdentityProviderClient({ region: CloudformationOutputs['AWSRegion'] })
            const userName = formFields["userName"]
            const newPassword = formFields["newPassword"]
            const session = authChallenge['Session']
            const cognitoId = authChallenge['ChallengeParameters']['USER_ID_FOR_SRP']
            

            const command = new RespondToAuthChallengeCommand({
                ClientId: CloudformationOutputs['UserPoolClientId'],
                ChallengeName: 'NEW_PASSWORD_REQUIRED',
                Session: session,
                ChallengeResponses: {
                  USERNAME: cognitoId,
                  NEW_PASSWORD: newPassword,
                  'userAttributes.name': userName
                },
              })
            client.send(command)
                .then((response: any) => {
                    setShowModal({ 'success': t('Auth.SetNewPasswordForm.passwordResetSuccess') })
                    setAuthChallenge(null)
                    navigate('/login')
                })
                .catch((error: any) => {
                    setShowModal({ "error": t('Auth.SetNewPasswordForm.passwordResetError') })
                    console.error("Error resetting password", error)
                })
            } 
    }




    return <div className={`w-full flex flex-col gap-4`}>

        <h3 className={`font-righteous text-2xl text-brand-dark`}>
            {t('Auth.SetNewPasswordForm.heading')}
        </h3>
 



        <Text
            labelText={t('Auth.SetNewPasswordForm.yourName')}
            formFields={formFields}
            formErrors={formErrors}
            setFormFields={setFormFields}
            fieldName={'userName'}
            size={'big'}
            center={true}
            required={true}
        />

        <Password
            labelText={t('Auth.SetNewPasswordForm.newPassword')}
            formFields={formFields}
            formErrors={formErrors}
            setFormFields={setFormFields}
            fieldName={'newPassword'}
            size={'big'}
            center={true}
            required={true}
        />

        <Password
            labelText={t('Auth.SetNewPasswordForm.newPasswordConfirm')}
            formFields={formFields}
            formErrors={formErrors}
            setFormFields={setFormFields}
            fieldName={'newPasswordConfirm'}
            size={'big'}
            center={true}
            required={true}
        />



        <div className={`w-full flex flex-row gap-4`}>
            <Button
                onClick={() => {setAuthChallenge(null) }}
                text={t('Buttons.cancel')}
                variant={'gray'}
                size={'big'}
                sameWindow={true}
            />
            <Button
                onClick={validateAndSave}
                text={t('Buttons.save')}
                variant={'secondary'}
                size={'big'}
                sameWindow={true}
            />
        </div>
    </div>
}
export default SetNewPasswordForm